import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import InputWrapper from "../../../layout/inputWrapper";
import FileUploader from "../../../reusableComponents/FileUploader2";
import ScrollButton from "../../../../../../../../core/src/pages/citizen/Home/AwasBandhu/UpwardScrollButton";
import { genderData, statesName } from "../../../../TCPForms/data";
import { shallowEqual, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ownerEntry = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE",
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT",
  },
};

const SubStep1 = ({ formData, handleSubTabChange, applicationFlow, officesList, avpData, avpUnits, isEmployee, isApproved, id, setShowToast }) => {
  const { documents } = useSelector((state) => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const { t } = useTranslation();
  const userInfo = Digit.UserService.getUser();

  const roles = userInfo?.info?.roles || [];

  const isLtp = roles.some(
    (role) =>
      !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role.code)
  );

  const isOwner =
    roles.some((role) => role.code === "OWNER") && !isLtp;

  const defaultMobileNumber = isOwner
    ? formData?.professionalInformation?.mobileNumber || ""
    : "";

  const defaultValues = {
    ...formData,

    department: applicationFlow,

    landInfo: {
      ...formData?.landInfo,

      owners:
        formData?.landInfo?.owners?.length > 0
          ? formData.landInfo.owners.map((owner, index) => ({
            ...owner,

            // Set mobile number only when user is OWNER
            mobileNumber:
              index === 0
                ? owner?.mobileNumber || defaultMobileNumber
                : owner?.mobileNumber || "",
          }))
          : [
            {
              ...ownerEntry,

              // Default for first owner only if OWNER
              mobileNumber: defaultMobileNumber,
            },
          ],
    },

    mobileNumber: defaultMobileNumber,

    documents,
  };

  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  // const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const updistricts = isDistrictDataLoading
    ? []
    : districtData.map((district) => ({
      label: district.name,
      value: district.name,
      name: district.name,
    }));
  console.log("upDIstricts", updistricts);

  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const { handleSubmit, control, reset, watch, setValue, trigger } = useForm({ defaultValues });
  const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
    control,
    name: "landInfo.owners",
  });
  const watchState = (idx) => watch(`landInfo.owners[${idx}].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || formData?.selectedOffice;
  const watchSelectedOffice = isDA ? watchOffice?.split("Development Authority")[0].trim() : watchOffice?.split(",")[1]?.trim();
  const watchUnit = watch("selectedUnit") || formData?.selectedUnit;
  const watchCity = watch("selectedCity") || formData?.selectedCity;
  const filterCities = (unit, masterData) => {
    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.map((item) => {
        return { name: item.City, label: item.City, value: item.City };
      });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData?.location1);
  }, [formData?.location1]);

  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      try {
        if (isDA && watchSelectedOffice) {
          const location = watchSelectedOffice;
          const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
          setValue("businessService", res);
        } else if (!isDA && watchUnit && watchCity) {
          const location2 = watchCity;
          const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
          setValue("businessService", res);
        } else {
          // If neither condition is met, clear businessService
          setValue("businessService", null);
        }
      } catch (error) {
        console.error("Error fetching business services:", error);
        // Optionally set an error state to show user feedback
      } finally {
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice, isDA, applicationFlow]);

  const validateFiles = () => {
    const uploadedDocs = documents?.map((doc) => doc.documentType);
    // const isValid = ["signature"].every((doc) => uploadedDocs.includes(doc));
    // const isValid = ["signature"].every((doc) => uploadedDocs.includes(doc));
    // return isValid;
    const isValid = owners?.every((_, index) => uploadedDocs?.includes(`signature_${index}`));
    console.log("Validation Result:", isValid);
    return isValid;
  };

  const validateDistinctMobileNumbers = (ownersList) => {
    const allMobileNumbers = ownersList?.map((owner) => owner.mobileNumber);
    const uniqueMobileNumbers = new Set(allMobileNumbers);
    return uniqueMobileNumbers.size === allMobileNumbers.length;
  };

  const validateDistinctAdhaarNumbers = (ownersList) => {
    const allAdhaarNumbers = ownersList?.map((owner) => owner.aadhaarNumber);
    const uniqueAdhaarNumbers = new Set(allAdhaarNumbers);
    return uniqueAdhaarNumbers.size === allAdhaarNumbers.length;
  };

  const onSubmit = (data) => {
    const ownerMobile = data.landInfo?.owners?.[0]?.mobileNumber;
    if (isLtp) {
      const isOwnerMobileSame = data.landInfo?.owners?.some((owner) => owner.mobileNumber === userInfo?.info?.mobileNumber);

      if (isOwnerMobileSame) {
        setShowToast({
          error: true,
          message: `Owner's mobile number and LTP's mobile number can't be same`,
        });
        return;
      }
    }
    if (!validateDistinctMobileNumbers(data.landInfo?.owners)) {
      setShowToast({
        error: true,
        message: `Mobile numbers must be distinct`,
      });
      return;
    }
    if (!validateDistinctAdhaarNumbers(data.landInfo?.owners)) {
      setShowToast({
        error: true,
        message: `Aadhaar numbers must be distinct`,
      });
      return;
    }
    const isValid = validateFiles();
    if (isValid) {
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity,
            },
          },
        },
      };
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Verifying Authority</h2>
          </div>
          {isDA ? (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={"Select Development Authority"}
                    inputLabel="Select office"
                    placeholder="Select office"
                    name="selectedOffice"
                    type={formData?.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect"}
                    defaultValue={formData?.selectedOffice}
                    data={SortingAlphabatically(officesList)}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={formData?.selectedOffice || isEmployee || isApproved}
                  />
                </Col>
              </Row>
            </Container>
          ) : (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="searchSelect"
                    data={SortingAlphabatically(avpUnits)}
                    defaultValue={formData?.selectedUnit || ""}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col>
                {watchUnit ? (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select City"}
                      inputLabel="Select city"
                      placeholder="Select city"
                      name="selectedCity"
                      type="searchSelect"
                      data={SortingAlphabatically(avpCities)}
                      defaultValue={formData?.selectedCity}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </Container>
          )}

          {owners.map((owner, index) => (
            <React.Fragment key={owner.id}>
              <div className="formHeaderContainer" style={{ marginTop: "26px" }}>
                <h2 className="formHeading">{t(`Owner/Applicant ${index + 1} Details`)}</h2>
                {index > 0 && !isEmployee && !isApproved && (
                  <div style={{ textAlign: "right", marginBottom: "10px" }}>
                    <button
                      type="button"
                      className="remove-owner-btn"
                      onClick={() => removeOwner(index)}
                    >
                      ✖ Remove Owner
                    </button>
                  </div>
                )}
              </div>


              <Container className="formInputContainer common-app-form" fluid>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      label="Name"
                      control={control}
                      placeholder="Enter Name"
                      name={`landInfo.owners[${index}].name`}
                      type="specialChar"
                      allowedChars="&/, "
                      maxLength={200}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        // pattern: {
                        //   value: Digit.Utils.getPattern("Name"),
                        //   message: "Please enter only letters and spaces",
                        // },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Father Name / Husband Name"
                      placeholder="Enter Father Name /Husband Name"
                      name={`landInfo.owners[${index}].fatherOrHusbandName`}
                      type="specialChar"
                      allowedChars="&/, "
                      maxLength={200}
                      // mandatory
                      validation={
                        {
                          // required: {
                          //   value: true,
                          //   message: "This field is required",
                          // },
                          // pattern: {
                          //   value: Digit.Utils.getPattern("Name"),
                          //   message: "Please enter only letters and spaces",
                          // },
                        }
                      }
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label={t("Gender")}
                      placeholder={t("Gender")}
                      // name={`landInfo.owners[0].gender`}
                      name={`landInfo.owners[${index}].gender`}
                      type="searchSelect"
                      data={SortingAlphabatically(genderData)}
                      // defaultValue={formData?.landInfo?.owners?.[0]?.gender}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "Please select the gender",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Mobile Number"
                      placeholder="Enter Mobile Number"
                      name={`landInfo.owners[${index}].mobileNumber`}
                      // defaultValue={formData?.professionalInformation?.mobileNumber}
                      type="number"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("MobileNo"),
                          message: "Please enter valid mobile no",
                        },
                      }}
                      disabled={isEmployee || isApproved || (isOwner && !isLtp)}
                      maxLength={10}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      label="E-mail ID"
                      control={control}
                      placeholder="Enter E-mail ID"
                      name={`landInfo.owners[${index}].emailId`}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("Email"),
                          message: "Please enter valid email id",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      label="Aadhaar Number"
                      control={control}
                      placeholder="Enter Aadhaar Number"
                      name={`landInfo.owners[${index}].aadhaarNumber`}
                      type="number"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("AadharNo"),
                          message: "Please enter valid Aadhaar no",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                      maxLength={12}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="State"
                      placeholder={"Select State"}
                      defaultValue={owner.correspondenceAddress?.state}
                      name={`landInfo.owners[${index}].correspondenceAddress.state`}
                      type="selectInput"
                      disabled={isEmployee || isApproved}
                      data={statesName}
                      mandatory={true}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      data={watchState(index) === "Uttar Pradesh" ? updistricts : undefined}
                      label={t("LABEL_DISTRICT")}
                      placeholder={watchState(index) === "Uttar Pradesh" ? "Select District" : "Enter District"}
                      name={`landInfo.owners[${index}].correspondenceAddress.town`}
                      type={watchState(index) === "Uttar Pradesh" ? "searchSelect" : "textInput"}
                      mandatory
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("Name"),
                          message: "Please enter only letters and spaces",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                  {/* <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="District"
                    placeholder="Enter District"
                    name={`landInfo.owners[${index}].correspondenceAddress.town`}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col> */}
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Communication Address"
                      placeholder="Enter Communication Address"
                      name={`landInfo.owners[${index}].correspondenceAddress.address`}
                      type="textInput"
                      mandatory
                      maxLength={300}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("Address"),
                          message: "Please enter valid Address",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Pin Code"
                      placeholder="Enter Pin Code"
                      name={`landInfo.owners[${index}].correspondenceAddress.pinno`}
                      type="number"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("Pincode"),
                          message: "Please enter valid Pin Code",
                        },
                      }}
                      maxLength={6}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="custom-upload new-custom-uploader signature-attach-uploader">
                      {!isEmployee && !isApproved && (
                        <FileUploader
                          control={control}
                          // name="signature"
                          name={`signature_${index}`}
                          label="Attach Signature"
                          validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                          isMandatory
                          required
                          tab={2}
                          maxFiles={1}
                          showError={showError}
                        />
                      )}
                    </div>
                  </Col>
                  <Col>
                    {!isEmployee && !isApproved && (
                      <button
                        type="button"
                        className="add-owner-btn"
                        // onClick={() => appendOwner(ownerEntry)}
                        onClick={() =>
                          appendOwner({
                            ...ownerEntry,

                            // Fill only for OWNER users
                            mobileNumber: isOwner
                              ? formData?.professionalInformation?.mobileNumber || ""
                              : "",
                          })
                        }
                        style={{ marginTop: "40px" }}
                      >
                        + Add Owner
                      </button>
                    )}
                  </Col>
                </Row>
                <br />
              </Container>
            </React.Fragment>
          ))}

          <div className="footerContainer2">
            <div className="buttonWrapper">
              {!isEmployee && !isApproved && (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={"Save"}
                  type="submit"
                  disabled={loading}
                  sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                />
              )}
            </div>

            <ScrollButton />
          </div>


        </div>
      </form>
    </section>
  );
};

export default SubStep1;
